import React, { useEffect, useState } from "react";
import {
  deepCloneObject,
  pushToDataLayer,
  useConfig,
} from "@thekilroygroup/shared-ui";
import ButtonGroupCustom from "components/ButtonGroupCustom/ButtonGroupCustom";
import { IPreferredAirlinesFilter } from "hooks/translations.interfaces";
import { useTranslations } from "hooks/useTranslations";
import { useSelector } from "react-redux";

import {
  IAirline,
  IPreferredAirlines,
  changePreferredAirlines,
  filterSelector,
} from "redux/filters";

import { IFlexibleSearch } from "redux/searchForm";
import { useFetchAirlinesQuery } from "redux/services/airlinesSearch";
import { UseAppDispatch } from "redux/store";
import { Button, Box, Collapse, useTheme } from "@mui/material";

export default function PreferredAirlinesFilter() {
  const dispatch = UseAppDispatch();
  const { preferredAirlines, allAirlines } = useSelector(filterSelector);
  const [allAirlineCompanies, setallAirlineCompanies] = useState<IAirline[]>(
    [],
  );

  const { transitions } = useTheme();

  const { translations } = useTranslations();
  const translationsPreferredAirlinesFilter: IPreferredAirlinesFilter =
    deepCloneObject(
      translations.filters.filterTypes.filter((obj) => {
        return obj.filter === "preferredAirlines";
      })[0],
    );

  const checkForTouched = (nextPreferredAirlines: IPreferredAirlines) => {
    if (nextPreferredAirlines.airlines.length > 0) {
      return true;
    } else {
      return false;
    }
  };

  const handleChange = (option: IFlexibleSearch) => {
    let nextPreferredAirlines: IPreferredAirlines =
      deepCloneObject(preferredAirlines);

    if (nextPreferredAirlines.airlines.some((obj) => obj.id === option.id)) {
      nextPreferredAirlines.airlines = nextPreferredAirlines.airlines.filter(
        (item) => item.id !== option.id,
      );
      pushToDataLayer(
        `Toggle off: ${option.id} - ${option.title}`,
        "Filter - Airline",
      );
    } else {
      pushToDataLayer(
        `Toggle on: ${option.id} - ${option.title}`,
        "Filter - Airline",
      );
      nextPreferredAirlines.airlines.push(option);
    }

    nextPreferredAirlines.touched = checkForTouched(nextPreferredAirlines);
    dispatch(changePreferredAirlines(nextPreferredAirlines));
  };

  const handleDeselectAll = () => {
    let nextPreferredAirlines: IPreferredAirlines =
      deepCloneObject(preferredAirlines);
    nextPreferredAirlines.airlines = [];
    nextPreferredAirlines.touched = checkForTouched(nextPreferredAirlines);

    pushToDataLayer("Toggle off: all", "Filter - Airline");

    dispatch(changePreferredAirlines(nextPreferredAirlines));
  };

  const { appConfig } = useConfig();
  const { isFetching, isError, data } = useFetchAirlinesQuery({
    query: allAirlines,
    config: appConfig,
  });

  useEffect(() => {
    if (!isFetching && !isError) {
      let airlines: any = [];

      for (const key in data) {
        if (key !== "") {
          airlines.push({
            id: key,
            title: data[key],
          });
        }
      }
      setallAirlineCompanies(airlines);
    }
  }, [isFetching, data]);

  return (
    <Box sx={{ mt: 3 }}>
      <ButtonGroupCustom
        onChange={handleChange}
        selected={preferredAirlines.airlines}
        options={allAirlineCompanies}
        align="top-left"
      />
      <Collapse
        in={preferredAirlines.airlines.length > 0}
        easing={transitions.easing.easeIn}
        timeout={transitions.duration.shortest}
      >
        <Button onClick={handleDeselectAll} variant="text" edge="start">
          {translationsPreferredAirlinesFilter.deselectAllText}
        </Button>
      </Collapse>
    </Box>
  );
}
